'use strict';

const clearSvg = require('../../images/clear.svg');

angular.module('docketbook').
  controller('checklistModalController', function($rootScope, $scope, $state, $stateParams, accessControl, $timeout, geolocation) {
    $scope.clearSvgImagePath = clearSvg;
    $scope.checklistDetail = {};

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.openChecklistFromParent = function(checklistsData, checklist, cb) {
      $("#checklistDetailModal").fadeIn(100);
      $scope.checklistCallback = cb;
      $scope.checklistDetail = checklist;
      $scope.checklistsData = angular.copy(checklistsData);
    }

    /*******************************/
    /***** Checklist Functions *****/
    /*******************************/

    $scope.saveChecklistDetail = function() {
      $scope.checklistCallback($scope.checklistsData);
      $("#checklistDetailModal").fadeOut(100);
    }

    $scope.closeChecklistDetailModal = function() {
      $("#checklistDetailModal").fadeOut(100);
      $scope.checklistCallback(null);
    }

    $scope.setChecklistItem = function(itemField, itemKey, newValue) {
      itemField[itemKey] = newValue;
    }

    $scope.resetChecklist = function(checklistDetail) {
      for ( var i = 0; i < checklistDetail.checklistTemplate.fields.length; i++ ) {
        var field = checklistDetail.checklistTemplate.fields[i];
        $scope.checklistsData[checklistDetail.checklistTemplate.id].answers[field.id] = "";
      }
      $scope.$parent.showToast('Checklist Reset');
    }

});



// WEBPACK FOOTER //
// ./src/controllers/modals/checklistModalController.js